import { render } from "./AssignUserPopup.vue?vue&type=template&id=58780602&scoped=true&ts=true"
import script from "./AssignUserPopup.vue?vue&type=script&lang=ts"
export * from "./AssignUserPopup.vue?vue&type=script&lang=ts"

import "./AssignUserPopup.vue?vue&type=style&index=0&id=58780602&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58780602"]])

export default __exports__